/* Körven Studio — page Favoris (grille compacte + barre récap) */
(function () {
  var root = document.querySelector('[data-ksw]');
  if (!root) return;
  var T = JSON.parse(root.querySelector('[data-ksw-i18n]').textContent);
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var grid = root.querySelector('[data-ksw-grid]');
  var empty = root.querySelector('[data-ksw-empty]');
  var loading = root.querySelector('[data-ksw-loading]');
  var countEl = root.querySelector('[data-ksw-count]');
  var shareBtn = root.querySelector('[data-ksw-share]');
  var sharedNote = root.querySelector('[data-ksw-shared-note]');
  var bar = document.querySelector('[data-ksw-bar]');
  var cache = {};
  var sel = {};
  var params = new URLSearchParams(window.location.search);
  var sharedParam = params.get('items');
  var shared = sharedParam ? sharedParam.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 60) : null;

  var fmt = (function (sample) {
    var m = sample.match(/^([^\d]*)([\d][\d\s.,'  ]*\d)([^\d]*)$/);
    if (!m) return null;
    var num = m[2];
    var digits = num.replace(/\D/g, '');
    var decimals = digits.length === 9 ? 2 : 0;
    var dec = decimals ? num.charAt(num.length - 3) : '';
    var thou = num.charAt(1).match(/\d/) ? '' : num.charAt(1);
    return { pre: m[1], post: m[3], decimals: decimals, dec: dec, thou: thou };
  })((root.getAttribute('data-money-sample') || '').trim());
  function money(cents) {
    if (!fmt) return (cents / 100).toFixed(2) + ' €';
    var n = (cents / 100).toFixed(fmt.decimals).split('.');
    var int = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thou);
    return fmt.pre + int + (fmt.decimals ? fmt.dec + n[1] : '') + fmt.post;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  var heartTpl = root.querySelector('[data-ksw-heart]');
  if (heartTpl) HEART = heartTpl.innerHTML.trim();
  var COLORISH = /couleur|color|colour|finition|bois|motif|teinte|mati|farbe|colore|kleur|kolor|farve|цвет/i;
  function imgFor(p, oi, label) {
    var s = sel[p.handle] || [];
    var m = p.variants.filter(function (v) { return v.options[oi] === label && v.image && v.options.every(function (o, i) { return i === oi || o === s[i]; }); })[0] || p.variants.filter(function (v) { return v.options[oi] === label && v.image; })[0];
    return m ? m.image.replace(/width=\d+/, "width=96") : null;
  }

  function handles() {
    if (shared) return shared;
    return (window.KSWishlist ? KSWishlist.read() : []).map(function (i) { return i.h; });
  }
  function stored(h) {
    if (shared || !window.KSWishlist) return null;
    var it = KSWishlist.read().filter(function (i) { return i.h === h; })[0];
    return it && it.v ? it.v : null;
  }

  function load(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch(base + 'products/' + encodeURIComponent(h) + '?view=ks-wish', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var p = JSON.parse(t.trim()); cache[h] = p; return p; })
      .catch(function () { cache[h] = { missing: true, handle: h }; return cache[h]; });
  }

  function initSel(p) {
    if (sel[p.handle]) return;
    var v = null;
    var sv = stored(p.handle);
    if (sv) v = p.variants.filter(function (x) { return x.id === sv; })[0];
    if (!v) v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    sel[p.handle] = v ? v.options.slice() : [];
  }
  function current(p) {
    var s = sel[p.handle] || [];
    return p.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === s[i]; });
    })[0] || null;
  }

  function card(p) {
    var v = current(p);
    var img = (v && v.image) || p.image;
    var price = v ? money(v.price) : '—';
    var opts = '';
    p.options.forEach(function (o, oi) {
      if (o.values.length < 2) return;
      var btns = o.values.map(function (val) {
        var on = (sel[p.handle] || [])[oi] === val.label;
        var a = ' role="radio" aria-checked="' + on + '" data-ksw-pick="' + oi + '" data-val="' + esc(val.label) + '"';
        var vimg = val.image || (!val.color && COLORISH.test(o.name) ? imgFor(p, oi, val.label) : null);
        if (val.color || vimg) {
          var bg = vimg ? 'background-image:url(' + esc(vimg) + ')' : 'background:' + esc(val.color);
          return '<button type="button" class="ksw-swatch"' + a + ' aria-label="' + esc(val.label) + '" title="' + esc(val.label) + '"><span style="' + bg + '"></span></button>';
        }
        return '<button type="button" class="ksw-pill"' + a + '>' + esc(val.label) + '</button>';
      }).join('');
      opts += '<div class="ksw-opt" role="radiogroup" aria-label="' + esc(o.name + ' — ' + p.name) + '">' + btns + '</div>';
    });
    var addLabel = !v ? T.unavailable : (v.available ? T.add : T.sold_out);
    return '<article class="ksw-card" data-h="' + esc(p.handle) + '">' +
      '<div class="ksw-card__media"><a href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img) + '" alt="" loading="lazy"></a>' +
      '<button type="button" class="ks-wl-btn is-active" data-ksw-remove aria-label="' + esc(T.remove.replace('[name]', p.name)) + '">' + HEART + '</button></div>' +
      '<div class="ksw-card__head"><h2 class="ksw-card__name"><a href="' + esc(p.url) + '">' + esc(p.name) + '</a></h2><span class="ksw-card__price">' + esc(price) + '</span></div>' +
      (p.subtitle ? '<p class="ksw-card__meta">' + esc(p.subtitle) + '</p>' : '') +
      opts +
      '<button type="button" class="ksw-card__add" data-ksw-add' + (v && v.available ? '' : ' disabled') + '>' + esc(addLabel) + '</button>' +
      '</article>';
  }

  var list = [];
  function render() {
    var hs = handles();
    if (shared) {
      sharedNote.hidden = false;
      if (shareBtn) shareBtn.hidden = true;
    }
    if (!hs.length) {
      list = [];
      grid.innerHTML = '';
      loading.hidden = true;
      empty.hidden = false;
      bar.hidden = true;
      countEl.textContent = '0';
      return;
    }
    empty.hidden = true;
    Promise.all(hs.map(load)).then(function (ps) {
      list = ps.filter(function (p) { return !p.missing && p.variants && p.variants.length; });
      list.forEach(initSel);
      loading.hidden = true;
      if (!list.length) { empty.hidden = false; bar.hidden = true; grid.innerHTML = ''; countEl.textContent = '0'; return; }
      grid.innerHTML = list.map(card).join('');
      summary();
    });
  }

  function markOverflow() {
    grid.querySelectorAll('.ksw-opt').forEach(function (o) {
      var over = o.scrollWidth > o.clientWidth + 2;
      o.classList.toggle('is-overflow', over);
      o.classList.toggle('is-end', over && o.scrollLeft + o.clientWidth >= o.scrollWidth - 4);
    });
  }
  grid.addEventListener('scroll', function (e) {
    var o = e.target;
    if (o.classList && o.classList.contains('ksw-opt')) o.classList.toggle('is-end', o.scrollLeft + o.clientWidth >= o.scrollWidth - 4);
  }, true);
  window.addEventListener('resize', function () { markOverflow(); });

  /* ---------- Filtre par type ----------
     Les types produit sont traduits selon la langue : chaque groupe liste les noms dans les 9 langues. */
  function norm(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[\s\-_]+/g, ' ').trim(); }
  var TYPE_NAMES = {
    wall: ['Applique Murale', 'Applique', 'Wall Light', 'Wall Lamp', 'Wall Sconce', 'Wandleuchte', 'Wandlampe', 'Applique da parete', 'Wandlamp', 'Aplique de pared', 'Aplique', 'Væglampe', 'Kinkiet', 'Настенный светильник', 'Бра'],
    pendant: ['Suspension', 'Pendant Light', 'Pendant Lamp', 'Pendant', 'Pendelleuchte', 'Hängeleuchte', 'Lampada a sospensione', 'Hanglamp', 'Lámpara colgante', 'Pendel', 'Pendellampe', 'Lampa wisząca', 'Подвесной светильник'],
    ceiling: ['Plafonnier', 'Ceiling Light', 'Ceiling Lamp', 'Deckenleuchte', 'Plafoniera', 'Plafondlamp', 'Plafón', 'Lámpara de techo', 'Loftlampe', 'Plafon', 'Потолочный светильник'],
    table: ['Lampe de Table', 'Lampe à poser', 'Table Lamp', 'Tischleuchte', 'Tischlampe', 'Lampada da tavolo', 'Tafellamp', 'Lámpara de mesa', 'Bordlampe', 'Lampa stołowa', 'Настольная лампа'],
    floor: ['Lampadaire', 'Floor Lamp', 'Stehleuchte', 'Stehlampe', 'Lampada da terra', 'Vloerlamp', 'Lámpara de pie', 'Gulvlampe', 'Lampa podłogowa', 'Торшер'],
    desk: ['Lampe de Bureau', 'Desk Lamp', 'Schreibtischleuchte', 'Schreibtischlampe', 'Lampada da scrivania', 'Bureaulamp', 'Lámpara de escritorio', 'Skrivebordslampe', 'Lampa biurkowa', 'Настольная лампа для кабинета'],
    cordless: ['Lampe Sans Fil', 'Lampe de Table Sans Fil', 'Cordless Lamp', 'Cordless Table Lamp', 'Kabellose Leuchte', 'Kabellose Lampe', 'Lampada senza fili', 'Snoerloze lamp', 'Lámpara inalámbrica', 'Trådløs lampe', 'Lampa bezprzewodowa', 'Беспроводная лампа']
  };
  var TYPE_GROUP = {};
  Object.keys(TYPE_NAMES).forEach(function (g) { TYPE_NAMES[g].forEach(function (n) { TYPE_GROUP[norm(n)] = g; }); });
  var GROUP_ORDER = ['pendant', 'wall', 'ceiling', 'table', 'floor', 'desk', 'cordless', 'other'];
  var filtersEl = root.querySelector('[data-ksw-filters]');
  var curF = 'all';
  function groupOf(p) { return TYPE_GROUP[norm(p.type)] || 'other'; }
  function chip(g, label, n) {
    return '<button type="button" class="ksw-chip" data-ksw-filter="' + g + '" aria-pressed="' + (curF === g) + '">' + esc(label) + ' <span>' + n + '</span></button>';
  }
  function applyFilter() {
    grid.querySelectorAll('.ksw-card').forEach(function (el) {
      var p = list.filter(function (x) { return x.handle === el.getAttribute('data-h'); })[0];
      el.hidden = !!(p && curF !== 'all' && groupOf(p) !== curF);
    });
    markOverflow();
  }
  function renderFilters() {
    if (!filtersEl) return;
    var counts = {};
    list.forEach(function (p) { var g = groupOf(p); counts[g] = (counts[g] || 0) + 1; });
    var groups = GROUP_ORDER.filter(function (g) { return counts[g]; });
    if (curF !== 'all' && !counts[curF]) curF = 'all';
    if (groups.length < 2) {
      curF = 'all';
      filtersEl.hidden = true;
      filtersEl.innerHTML = '';
      applyFilter();
      return;
    }
    var html = chip('all', T.filter_all, list.length);
    groups.forEach(function (g) { html += chip(g, (T.types && T.types[g]) || g, counts[g]); });
    filtersEl.innerHTML = html;
    filtersEl.hidden = false;
    applyFilter();
  }
  if (filtersEl) filtersEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ksw-filter]');
    if (!b) return;
    curF = b.getAttribute('data-ksw-filter');
    renderFilters();
    var again = filtersEl.querySelector('[data-ksw-filter="' + curF + '"]');
    if (again) again.focus();
  });

  function summary() {
    var total = 0;
    list.forEach(function (p) { var v = current(p); if (v && v.available) total += v.price; });
    countEl.textContent = String(list.length);
    bar.hidden = list.length === 0;
    bar.querySelectorAll('[data-ksw-total]').forEach(function (n) { n.textContent = money(total); });
    bar.querySelectorAll('[data-ksw-n]').forEach(function (n) { n.textContent = String(list.length); });
    var th = list.slice(0, 4).map(function (p) { var v = current(p); return '<img src="' + esc((v && v.image) || p.image) + '" alt="">'; }).join('');
    if (list.length > 4) th += '<span class="ksw-bar__more">+' + (list.length - 4) + '</span>';
    bar.querySelector('[data-ksw-thumbs]').innerHTML = th;
    renderFilters();
  }

  function cardOf(el) {
    var c = el.closest('.ksw-card');
    if (!c) return null;
    var h = c.getAttribute('data-h');
    return { el: c, p: list.filter(function (x) { return x.handle === h; })[0] };
  }

  grid.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-ksw-pick]');
    var rm = e.target.closest('[data-ksw-remove]');
    var add = e.target.closest('[data-ksw-add]');
    var c = cardOf(e.target);
    if (!c || !c.p) return;
    if (pick) {
      sel[c.p.handle][Number(pick.getAttribute('data-ksw-pick'))] = pick.getAttribute('data-val');
      var v = current(c.p);
      if (v && !shared && window.KSWishlist) KSWishlist.setVariant(c.p.handle, v.id);
      var tmp = document.createElement('div');
      tmp.innerHTML = card(c.p);
      var fresh = tmp.firstChild;
      var keep = Array.prototype.map.call(c.el.querySelectorAll('.ksw-opt'), function (o) { return o.scrollLeft; });
      c.el.replaceWith(fresh);
      Array.prototype.forEach.call(fresh.querySelectorAll('.ksw-opt'), function (o, i) { o.scrollLeft = keep[i] || 0; });
      var again = fresh.querySelector('[data-ksw-pick="' + pick.getAttribute('data-ksw-pick') + '"][data-val="' + CSS.escape(pick.getAttribute('data-val')) + '"]');
      if (again) again.focus();
      summary();
    } else if (rm) {
      if (shared) {
        shared = shared.filter(function (h) { return h !== c.p.handle; });
      } else if (window.KSWishlist) {
        KSWishlist.remove(c.p.handle);
      }
      list = list.filter(function (p) { return p.handle !== c.p.handle; });
      c.el.remove();
      if (!list.length) render(); else summary();
      toast(T.removed.replace('[name]', c.p.name));
    } else if (add) {
      var cv = current(c.p);
      if (!cv) return;
      addToCart([{ id: cv.id, quantity: 1 }], add);
    }
  });

  grid.addEventListener('keydown', function (e) {
    var b = e.target.closest('[data-ksw-pick]');
    if (!b || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) === -1) return;
    var all = Array.prototype.slice.call(b.parentNode.querySelectorAll('[data-ksw-pick]'));
    var i = all.indexOf(b) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
    var n = all[(i + all.length) % all.length];
    e.preventDefault();
    n.click();
  });

  var busy = false;
  function addToCart(items, btn) {
    if (busy) return Promise.resolve();
    busy = true;
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    if (btn) btn.disabled = true;
    /* sections_url = la page courante : rendue depuis /cart, la ligne du tiroir masque les boutons quantité / supprimer sur ordinateur */
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : T.error);
        return fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = res.j.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          busy = false;
          if (btn) {
            btn.disabled = false;
            if (btn.classList.contains('ksw-card__add')) {
              btn.classList.add('is-done');
              btn.textContent = T.added;
              setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = T.add; }, 2200);
            }
          }
        });
      })
      .catch(function (err) {
        busy = false;
        if (btn) btn.disabled = false;
        toast(err && err.message ? err.message : T.error);
      });
  }

  bar.querySelector('[data-ksw-add-all]').addEventListener('click', function (e) {
    var items = [];
    list.forEach(function (p) { var v = current(p); if (v && v.available) items.push({ id: v.id, quantity: 1 }); });
    if (items.length) addToCart(items, e.currentTarget);
  });

  if (shareBtn) shareBtn.addEventListener('click', function () {
    var hs = handles();
    if (!hs.length) return;
    var url = window.location.origin + window.location.pathname + '?items=' + hs.map(encodeURIComponent).join(',');
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast(T.copied); });
    } else {
      window.prompt(T.copy_prompt, url);
    }
  });

  var copyBtn = root.querySelector('[data-ksw-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    if (!shared || !window.KSWishlist) return;
    shared.slice().reverse().forEach(function (h) { if (!KSWishlist.has(h)) KSWishlist.add(h); });
    window.location.href = window.location.pathname;
  });

  var toastTimer;
  function toast(msg) {
    var t = document.querySelector('.ksw-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ksw-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  document.addEventListener('ks-wishlist:change', function () {
    if (shared) return;
    var hs = handles();
    var shown = list.map(function (p) { return p.handle; });
    var same = hs.length === shown.length && hs.every(function (h) { return shown.indexOf(h) !== -1; });
    if (!same) render();
  });
  window.addEventListener('storage', function (e) { if (e.key === 'ks-wishlist-v1' && !shared) render(); });

  render();
})();
